export default {"src":"/_next/static/media/instanst.d2693b4f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};